export default "__VITE_ASSET__jUmOrT10__"